module.exports = __webpack_public_path__ + "images/starpro-logo.f2b9feb195b26656190ae37f7382920a.svg";